export const categories = [
  { id: "all", name: "全部瓜田", count: 128 },
  { id: "variety", name: "综艺现场", count: 34 },
  { id: "series", name: "剧集热议", count: 29 },
  { id: "influencer", name: "网红圈", count: 26 },
  { id: "online", name: "网络话题", count: 21 },
  { id: "night", name: "深夜八卦", count: 18 },
];

export const topics = [
  {
    id: "t-1001",
    title: "某选秀节目选手临场退赛，是「真性情」还是「不受控」？",
    summary:
      "节目录制现场选手突然离场，官方只用一句话回应。有人觉得这是对赛制最直接的抗议，也有人认为对同组伙伴不够负责。瓜友们已经吵翻了，你站哪一边？",
    category: "variety",
    categoryName: "综艺现场",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E8%B0%83%E8%88%9E%E5%8F%B0%E8%81%9A%E5%85%89%E7%81%AF%E5%85%89%E4%B8%8E%E7%A9%BA%E6%A4%85%E5%AD%90%EF%BC%8C%E7%94%B5%E8%A7%86%E7%A7%80%E7%8E%B0%E5%9C%BA%E6%B0%9B%E5%9B%B4%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%B9%B2%E5%87%80%E7%AE%80%E6%B4%81%EF%BC%8C%E8%89%B2%E8%B0%83%E6%B8%A9%E6%9A%96%EF%BC%8C%E7%BA%B9%E7%90%86%E7%BB%86%E8%85%BB&width=800&height=600&seq=gualu-topic-1001&orientation=landscape&nocache=true",
    tags: ["赛制争议", "临场退赛", "站队中"],
    heat: 98600,
    votesA: 5820,
    votesB: 4310,
    commentCount: 1284,
    author: "瓜田值班员",
    time: "2 小时前",
    sideA: "支持选手",
    sideB: "理解节目组",
    hot: true,
  },
  {
    id: "t-1002",
    title: "古装剧大结局被指「烂尾」，是留白高级还是编剧偷懒？",
    summary:
      "追了三个月的剧，最后一集没有交代任何一条主线。观众分成两派：一派认为留白让人回味，一派觉得这是把观众当傻子。",
    category: "series",
    categoryName: "剧集热议",
    cover:
      "https://readdy.ai/api/search-image?query=%E4%B8%AD%E5%BC%8F%E5%8F%A4%E9%A3%8E%E5%B1%8F%E9%A3%8E%E4%B8%8E%E6%9A%97%E7%BA%A2%E8%89%B2%E6%88%8F%E6%9C%8D%E7%BB%86%E8%8A%82%EF%BC%8C%E6%9F%94%E5%92%8C%E6%9A%96%E5%85%89%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%85%8B%E5%88%B6%E9%9B%85%E8%87%B4%EF%BC%8C%E5%85%B7%E6%9C%89%E7%94%B5%E5%BD%B1%E8%B4%A8%E6%84%9F&width=800&height=600&seq=gualu-topic-1002&orientation=landscape&nocache=true",
    tags: ["大结局", "烂尾争议", "编剧回应"],
    heat: 82300,
    votesA: 3120,
    votesB: 5480,
    commentCount: 963,
    author: "追剧不睡觉",
    time: "5 小时前",
    sideA: "留白高级",
    sideB: "编剧偷懒",
    hot: true,
  },
  {
    id: "t-1003",
    title: "头部主播直播间突然掉线三小时，粉丝说是「被打压」？",
    summary:
      "一场原定四个小时的带货直播中途黑屏，复播后主播只字未提。各种猜测在评论区蔓延，但没有任何一方给出正式说明。",
    category: "influencer",
    categoryName: "网红圈",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E7%9B%B4%E6%92%AD%E9%97%B4%E8%83%8C%E6%99%AF%EF%BC%8C%E6%A1%8C%E9%9D%A2%E4%B8%8A%E6%91%86%E7%9D%80%E7%9B%B8%E6%9C%BA%E4%B8%8E%E7%81%AF%E5%85%89%E8%AE%BE%E5%A4%87%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%B9%B2%E5%87%80%E6%9F%94%E5%92%8C%EF%BC%8C%E7%BB%86%E8%8A%82%E4%B8%B0%E5%AF%8C&width=800&height=600&seq=gualu-topic-1003&orientation=landscape&nocache=true",
    tags: ["直播事故", "猜测满天飞", "理性吃瓜"],
    heat: 74500,
    votesA: 6230,
    votesB: 2180,
    commentCount: 742,
    author: "深夜刷直播",
    time: "昨天",
    sideA: "另有隐情",
    sideB: "就是故障",
    hot: false,
  },
  {
    id: "t-1004",
    title: "综艺剪辑被指「恶剪」，观众拿原片逐帧对比后炸了",
    summary:
      "有观众把正片和花絮逐帧对比，发现同一段对话被剪成完全相反的意思。关于「综艺剪辑到底有没有底线」，讨论已经冲上热搜话题榜。",
    category: "variety",
    categoryName: "综艺现场",
    cover:
      "https://readdy.ai/api/search-image?query=%E7%94%B5%E8%A7%86%E8%8A%82%E7%9B%AE%E5%90%8E%E6%9C%9F%E5%89%AA%E8%BE%91%E5%B7%A5%E4%BD%9C%E5%8F%B0%EF%BC%8C%E5%A4%9A%E5%B1%8F%E7%94%BB%E9%9D%A2%E4%B8%8E%E6%97%B6%E9%97%B4%E8%BD%B4%EF%BC%8C%E6%9A%96%E8%89%B2%E5%85%89%EF%BC%8C%E7%94%BB%E9%9D%A2%E6%95%B4%E6%B4%81%E6%9C%89%E7%A7%91%E6%8A%80%E6%84%9F&width=800&height=600&seq=gualu-topic-1004&orientation=landscape&nocache=true",
    tags: ["恶剪争议", "逐帧对比", "剪辑伦理"],
    heat: 69100,
    votesA: 4890,
    votesB: 3620,
    commentCount: 611,
    author: "逐帧看综艺",
    time: "昨天",
    sideA: "确实恶剪",
    sideB: "被过度解读",
    hot: false,
  },
  {
    id: "t-1005",
    title: "某头部账号被扒「人设崩塌」，粉丝却在评论区集体控评？",
    summary:
      "账号早期言论与近期人设明显矛盾，评论区却整齐地进行「控评」。有人觉得这是粉丝护主，也有人认为背后有组织运营。",
    category: "online",
    categoryName: "网络话题",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E6%A1%8C%E9%9D%A2%E4%B8%8A%E6%91%86%E6%94%BE%E7%9D%80%E6%89%8B%E6%9C%BA%E4%B8%8E%E7%AC%94%E8%AE%B0%E6%9C%AC%EF%BC%8C%E5%B1%8F%E5%B9%95%E5%BE%AE%E5%85%89%EF%BC%8C%E7%94%BB%E9%9D%A2%E7%AE%80%E6%B4%81%E6%9C%89%E7%94%9F%E6%B4%BB%E6%84%9F%EF%BC%8C%E9%85%8D%E8%89%B2%E6%B8%A9%E6%9A%96&width=800&height=600&seq=gualu-topic-1005&orientation=landscape&nocache=true",
    tags: ["人设争议", "控评", "网络观察"],
    heat: 61200,
    votesA: 3980,
    votesB: 4520,
    commentCount: 528,
    author: "赛博显微镜",
    time: "2 天前",
    sideA: "人设确实有问题",
    sideB: "被断章取义",
    hot: false,
  },
  {
    id: "t-1006",
    title: "两位演员发布会全程零互动，是「真有矛盾」还是「尴尬营业」？",
    summary:
      "新剧发布会上主演全程没有眼神交流，采访时也各说各话。剧方的解释是「档期太赶」，但观众显然不太买账。",
    category: "night",
    categoryName: "深夜八卦",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E5%8F%91%E5%B8%83%E4%BC%9A%E8%88%9E%E5%8F%B0%EF%BC%8C%E7%A9%BA%E6%A4%85%E5%AD%90%E4%B8%8E%E8%AF%9D%E7%AD%92%EF%BC%8C%E7%81%AF%E5%85%89%E6%9F%94%E5%92%8C%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%85%8B%E5%88%B6%E9%9B%85%E8%87%B4%EF%BC%8C%E7%95%99%E7%99%BD%E5%85%85%E8%B6%B3&width=800&height=600&seq=gualu-topic-1006&orientation=landscape&nocache=true",
    tags: ["发布会", "零互动", "猜测不断"],
    heat: 55800,
    votesA: 5240,
    votesB: 1760,
    commentCount: 486,
    author: "瓜田值班员",
    time: "2 天前",
    sideA: "真有矛盾",
    sideB: "只是营业",
    hot: false,
  },
  {
    id: "t-1007",
    title: "短剧男主被指「轧戏」，一天只睡两小时的说法你信吗？",
    summary:
      "有工作人员爆料某短剧男主同时进组两部戏，另一部男主戏份大量使用替身。剧组尚未回应，短剧行业的超负荷问题被重新讨论。",
    category: "influencer",
    categoryName: "网红圈",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E7%9F%AD%E8%A7%86%E9%A2%91%E6%8B%8D%E6%91%84%E7%8E%B0%E5%9C%BA%EF%BC%8C%E6%91%84%E5%83%8F%E6%9C%BA%E4%B8%8E%E7%81%AF%E6%9E%B6%EF%BC%8C%E7%94%BB%E9%9D%A2%E7%AE%80%E6%B4%81%E6%B8%A9%E6%9A%96%EF%BC%8C%E7%BB%86%E8%8A%82%E7%9C%9F%E5%AE%9E&width=800&height=600&seq=gualu-topic-1007&orientation=landscape&nocache=true",
    tags: ["轧戏", "行业现象", "等待回应"],
    heat: 47300,
    votesA: 3410,
    votesB: 2890,
    commentCount: 372,
    author: "追剧不睡觉",
    time: "3 天前",
    sideA: "确实轧戏",
    sideB: "消息不实",
    hot: false,
  },
  {
    id: "t-1008",
    title: "粉丝应援花墙被拆，是「公共秩序优先」还是「矫枉过正」？",
    summary:
      "场外应援花墙因占道被临时拆除，粉丝与路人各执一词。这已经不是第一次因为应援引发公共空间争议了。",
    category: "online",
    categoryName: "网络话题",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E5%9F%8E%E5%B8%82%E8%A1%97%E9%81%93%E4%B8%80%E8%A7%92%EF%BC%8C%E8%8A%B1%E6%9D%9F%E4%B8%8E%E7%81%AF%E7%89%8C%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%B9%B2%E5%87%80%E6%9F%94%E5%92%8C%EF%BC%8C%E5%85%89%E7%BA%BF%E6%B8%A9%E6%9A%96&width=800&height=600&seq=gualu-topic-1008&orientation=landscape&nocache=true",
    tags: ["应援", "公共空间", "规则讨论"],
    heat: 41900,
    votesA: 2760,
    votesB: 3340,
    commentCount: 298,
    author: "赛博显微镜",
    time: "3 天前",
    sideA: "秩序优先",
    sideB: "矫枉过正",
    hot: false,
  },
];

export const pkBattles = [
  {
    id: "pk-1",
    question: "没有证据的爆料，应不应该被公开讨论？",
    tag: "本周最热 PK",
    leftLabel: "可以讨论",
    leftDesc: "话题本身就是公共讨论的一部分，理性围观能倒逼真相",
    leftVotes: 8420,
    rightLabel: "不该扩散",
    rightDesc: "没有证据的指控会误伤当事人，先核实再传播",
    rightVotes: 9680,
  },
  {
    id: "pk-2",
    question: "综艺剪辑为了效果制造冲突，你能接受吗？",
    tag: "剪辑伦理",
    leftLabel: "可以接受",
    leftDesc: "综艺本来就有娱乐属性，节目好看最重要",
    leftVotes: 5210,
    rightLabel: "不能接受",
    rightDesc: "剪辑改变事实等于误导观众，必须有底线",
    rightVotes: 7140,
  },
  {
    id: "pk-3",
    question: "粉丝控评是「保护偶像」还是「掩盖问题」？",
    tag: "饭圈观察",
    leftLabel: "是保护",
    leftDesc: "评论区被恶意带节奏时，粉丝有权利维护",
    leftVotes: 3980,
    rightLabel: "是掩盖",
    rightDesc: "整齐的控评只会让真实声音消失",
    rightVotes: 6820,
  },
];

export const remixArticles = [
  {
    id: "r-1",
    title: "把「临场退赛」拆开看：一个综艺赛制的三种可能走向",
    excerpt:
      "退赛只是结果，真正值得聊的是赛制设计。我们用三条线索，还原这场风波背后节目组与选手各自的处境。",
    author: "瓜田深度组",
    readTime: "8 分钟",
    tag: "二创解读",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E7%BA%B8%E9%9D%A2%E4%B8%8E%E7%AC%94%E8%AE%B0%EF%BC%8C%E6%9C%89%E6%89%8B%E5%86%99%E7%AC%94%E8%AE%B0%E7%9A%84%E7%BB%86%E8%8A%82%EF%BC%8C%E7%94%BB%E9%9D%A2%E7%AE%80%E6%B4%81%E6%B8%A9%E6%9A%96%EF%BC%8C%E9%80%82%E5%90%88%E6%96%87%E7%AB%A0%E5%B0%81%E9%9D%A2&width=640&height=480&seq=gualu-remix-01&orientation=landscape&nocache=true",
  },
  {
    id: "r-2",
    title: "「烂尾」到底是编剧问题还是播出机制问题？",
    excerpt:
      "从剧本结构到排播方式，我们梳理了最近五部被指烂尾的剧集，发现了一个共同点。",
    author: "追剧研究室",
    readTime: "6 分钟",
    tag: "二创解读",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E4%B9%A6%E6%A1%8C%E4%B8%8A%E6%91%86%E6%94%BE%E7%9D%80%E8%84%9A%E6%9C%AC%E4%B8%8E%E8%80%B3%E6%9C%BA%EF%BC%8C%E6%9F%94%E5%92%8C%E5%85%89%E7%BA%BF%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%AE%89%E9%9D%99%E8%88%92%E9%80%82&width=640&height=480&seq=gualu-remix-02&orientation=landscape&nocache=true",
  },
  {
    id: "r-3",
    title: "控评话术图鉴：五类高频句式是怎么被批量复制的",
    excerpt:
      "我们收集了上千条评论，把它们按句式归类。你会发现，所谓「民意」其实有很明显的模板痕迹。",
    author: "赛博观察室",
    readTime: "7 分钟",
    tag: "数据解读",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E5%B1%8F%E5%B9%95%E4%B8%8A%E7%9A%84%E6%95%B0%E6%8D%AE%E5%9B%BE%E8%A1%A8%EF%BC%8C%E6%A1%8C%E9%9D%A2%E5%B9%B2%E5%87%80%EF%BC%8C%E7%94%BB%E9%9D%A2%E7%AE%80%E6%B4%81%E6%9C%89%E7%A7%91%E6%8A%80%E6%84%9F%EF%BC%8C%E8%89%B2%E8%B0%83%E6%B8%A9%E6%9A%96&width=640&height=480&seq=gualu-remix-03&orientation=landscape&nocache=true",
  },
  {
    id: "r-4",
    title: "应援与公共空间：一场持续了十年的边界讨论",
    excerpt:
      "从应援物到花墙，粉丝文化与城市秩序的碰撞从未停止。我们试着把这条时间线讲清楚。",
    author: "瓜田深度组",
    readTime: "9 分钟",
    tag: "二创解读",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E5%9F%8E%E5%B8%82%E8%A1%97%E9%81%93%E4%B8%8E%E8%A1%8C%E4%BA%BA%E5%89%AA%E5%BD%B1%EF%BC%8C%E6%9F%94%E5%92%8C%E9%BB%84%E6%98%8F%E5%85%89%E7%BA%BF%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%B9%B2%E5%87%80%E7%AE%80%E6%B4%81&width=640&height=480&seq=gualu-remix-04&orientation=landscape&nocache=true",
  },
];

export const faqs = [
  {
    q: "「网爆黑料」里的内容都是真实的吗？",
    a: "本站内容均来自公开话题的整理与再讨论，涉及的对象和情节均为抽象的虚构设定，不指向任何真实个人。我们更关注「大家怎么想」，而不是「到底是谁」。",
  },
  {
    q: "站队投票会记录我的选择吗？",
    a: "当前演示版本中，你的站队结果会保存在你自己的浏览器里，用于展示票数变化效果，不会上传给任何人。后续接入账号体系后才会同步到你的个人记录。",
  },
  {
    q: "观点 PK 的票数是实时的吗？",
    a: "PK 票数会随着每位瓜友的投票实时增长，页面刷新后仍保留你在本次浏览中的选择，方便你对比双方观点的支持比例。",
  },
  {
    q: "评论有内容规范吗？",
    a: "有，而且很重要。我们禁止人身攻击、人肉搜索、编造证据和泄露隐私。评论区出现以上内容会被折叠，多次违规会被限制发言。理性吃瓜，才是长久之计。",
  },
  {
    q: "我可以投稿「二创解读」吗？",
    a: "可以。只要你的解读基于公开信息、逻辑清晰、不带恶意指向，就可以通过「联系编辑部」提交。我们会挑选优质内容发布在二创解读栏目。",
  },
];

export const communityRules = [
  { icon: "ri-shield-check-line", title: "不人肉、不泄私", desc: "任何真实姓名、联系方式、住址等隐私信息一律不允许出现。" },
  { icon: "ri-scales-3-line", title: "有观点，有依据", desc: "欢迎立论和辩论，请把「我觉得」和「我查到」分开说明。" },
  { icon: "ri-chat-smile-2-line", title: "对事不对人", desc: "可以激烈讨论话题本身，但禁止辱骂、羞辱和群体攻击。" },
  { icon: "ri-error-warning-line", title: "不传谣、不加料", desc: "未经证实的内容请标明「存疑」，不要二次加工成「实锤」。" },
];